import * as React from 'react';
import { Icon, CompanyAvatar } from '../';
import BaseList from '../BaseList/BaseList';
import IconAvatar from '../IconAvatar/IconAvatar';
import DateTime from '../DateTime/DateTime';

interface Props {
  items: Array<any>;
  showEmail?: boolean;
  showJoinDate?: boolean;
  handleClick?: any;
  hideSearch?: boolean;
  renderBody?: any;
  noAnimation?: boolean;
  isSelected?: (id: number) => boolean;
  small?: boolean;
}

class CompanyList extends BaseList<Props> {
  constructor(props) {
    super(props, {
      fields: BaseList.fields.companies.search,
      search: BaseList.search.companies,
      path: 'companies',
      name: 'companies',
    });
  }

  isSelected(company) {
    return this.props.isSelected && this.props.isSelected(company.id);
  }

  renderLeft(company) {
    if (this.isSelected(company)) {
      return <IconAvatar icon="check" colour="#345dc3" iconColour="#fff" />;
    }
    return (
      <CompanyAvatar size={this.props.small ? '48' : '64'} company={company} />
    );
  }

  renderFoot(company) {
    return null;
  }

  renderHead(company) {
    return (
      <div>
        {this.props.showJoinDate && (
          <small className="is-pulled-right has-text-grey">
            Created <DateTime date={company.created_at} />
          </small>
        )}
        <strong style={this.isSelected(company) ? { color: '#345dc3' } : {}}>
          {company.name}
        </strong>
      </div>
    );
  }

  renderBody(company) {
    const body = [];
    if (company.phone_number) {
      body.push(
        <div key="phone_number">
          <small>
            <Icon icon="phone has-text-grey-light" />
            &nbsp;
            {company.phone_number}
          </small>
        </div>,
      );
    }
    if (company.city) {
      body.push(
        <div key="city">
          <small>
            <Icon icon="map-pin has-text-grey-light" />
            &nbsp;
            {company.city}
          </small>
        </div>,
      );
    }
    return body;
  }
}

export default CompanyList;
